<template>
  <div class="add-place-image-form">
    <TitleBar :text="$t('AddPlaceImageForm.topic')" :showIconButton="false" @clickCloseButton="clickCloseButton" />
    <div class="body">
      <div class="image" v-for="(image, i) in imageList" :key="`image-${i}`">
        <img :src="image.preview" @click="clickImage(i)">
        <div class="row">
          <img class="edit-icon" :src="util.getImagePath(`edit_light_black@2x.png`)" :srcset="util.getImageSet(`edit_light_black`)" @click="clickImage(i)">
          <input type="text" v-model="image.comment" :placeholder="$t('AddPlaceImageForm.commentPlaceholder')">
          <button class="delete-button" @click="deleteImage(i)">
            <img :src="util.getImagePath(`delete_light_black@2x.png`)" :srcset="util.getImageSet(`delete_light_black`)">
          </button>
        </div>
      </div>
      <div class="image add" @click="clickAddImage">
        <img :src="util.getImagePath('add_photo_blue@2x.png')" :srcset="util.getImageSet('add_photo_blue')">
        <input ref="add-image-input" class="add-image-input" type="file" accept="image/*" @change="manageImageList()" v-show="false" multiple>
      </div>
    </div>
    <div class="backdrop" v-show="isSaving">
      <div class="loading-animation" v-if="uploadPercentage >= 100"></div>
      {{ uploadPercentage >= 100 ? $t('AddPlaceImageForm.processing') : $t('AddPlaceImageForm.uploading') }}
    </div>
    <div class="on-upload" v-show="isSaving" :style="{width: `${uploadPercentage}%`}"></div>
    <div class="footer">
      <button class="cancel-button" @click="clickCloseButton">{{ $t('AddPlaceImageForm.cancel') }}</button>
      <button class="save-button" @click="clickSave" :disabled="isSaving">{{ $t('AddPlaceImageForm.save') }}</button>
    </div>
  </div>
</template>

<script>
import TitleBar from '@/components/TitleBar.vue'

export default {
  name: 'AddPlaceIMageForm',
  components: {
    TitleBar
  },
  props: {
    promptpaiDescription: {
      type: Object,
      default: undefined
    },
    initImageList: {
      type: Array,
      default: () => {
        return []
      }
    },
    immediately: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isSaving: false,
      uploadPercentage: 0,
      cancelAddingPromptpaiImage: undefined,
      imageList: this.initImageList
    }
  },
  mounted () {
    const self = this
    self.$root.$on('rotate', self.rotate)
    self.$root.$on('hFlip', self.hFlip)
    self.$root.$on('vFlip', self.vFlip)
    if (self.immediately) {
      self.clickAddImage()
    }
  },
  methods: {
    clickImage (index) {
      var self = this
      self.$root.$emit('openImageFullscreen', {
        src: self.imageList[index].original,
        index
      })
    },
    clickCloseButton () {
      var self = this
      if (self.cancelAddingPromptpaiImage) {
        self.cancelAddingPromptpaiImage()
      }
      self.$router.back()
    },
    deleteImage (index) {
      var self = this
      self.imageList.splice(index, 1)
    },
    clickAddImage () {
      var self = this
      if (self.util.getUserAgentMeta() === 'iOS application' || self.util.getUserAgentMeta() === 'Android application') {
        window.selectImageFile = (ref, base64List) => {
          for (var i = 0; i < base64List.length; i++) {
            base64List[i] = `data:image/png;base64,${base64List[i]}`
          }
          self.manageImageListForNativeApp(base64List)
        }
        window.blockSelectImageFile = () => {
          console.log('blockSelectImageFile')
        }
        window.location.href = 'https://native.selectImageFile?ref=addplaceimageform&multiple=1'
      } else {
        self.$refs[`add-image-input`].click()
      }
    },
    manageImageList () {
      var self = this
      var imageFileList = self.$refs[`add-image-input`].files

      var loadImage = (index) => {
        return (e) => {
          self.util.resizeImage(e.target.result, 2048, 2048, self.imageList[index].orientation, (originalUrl) => {
            self.imageList[index].original = originalUrl
          })
          self.util.resizeImage(e.target.result, 640, 640, self.imageList[index].orientation, (previewUrl) => {
            self.imageList[index].preview = previewUrl
          })
        }
      }

      var orientationCallback = function (index) {
        return (orientation) => {
          self.imageList[index].orientation = orientation
          var reader = new FileReader()
          reader.onload = loadImage(index)
          reader.readAsDataURL(self.imageList[index].file)
        }
      }

      for (var i = 0; i < imageFileList.length; i++) {
        if (imageFileList[i]) {
          self.imageList.push({
            file: imageFileList[i],
            original: imageFileList[i],
            preview: '',
            comment: '',
            orientation: -1
          })
          // self.util.getOrientation(
          //   self.imageList[self.imageList.length - 1].file,
          //   orientationCallback(self.imageList.length - 1)
          // )
          orientationCallback(self.imageList.length - 1)(self.imageList[self.imageList.length - 1].orientation)
        }
      }
      self.$refs[`add-image-input`].value = ''
    },
    manageImageListForNativeApp (base64List) {
      var self = this

      var loadOriginalImage = (index) => {
        return (url) => {
          self.imageList[index].file = url
          self.imageList[index].original = url
        }
      }

      var loadImage = (index) => {
        return (previewUrl) => {
          self.imageList[index].preview = previewUrl
        }
      }

      for (var i = 0; i < base64List.length; i++) {
        if (base64List[i]) {
          self.imageList.push({
            // file: self.util.createFileFromUrl(base64List[i]),
            file: base64List[i],
            original: base64List[i],
            preview: '',
            comment: '',
            orientation: -1
          })
          self.util.resizeImage(
            self.imageList[self.imageList.length - 1].original,
            2048,
            2048,
            self.imageList[self.imageList.length - 1].orientation,
            loadOriginalImage(self.imageList.length - 1)
          )
          self.util.resizeImage(
            self.imageList[self.imageList.length - 1].original,
            640,
            640,
            self.imageList[self.imageList.length - 1].orientation,
            loadImage(self.imageList.length - 1)
          )
        }
      }

      self.$refs[`add-image-input`].value = ''
    },
    rotate (index) {
      var self = this
      self.util.resizeImage(self.imageList[index].original, -1, -1, 6, (originalUrl) => {
        self.imageList[index].original = originalUrl
        self.clickImage(index)
      })
      self.util.resizeImage(self.imageList[index].original, 640, 640, 6, (previewUrl) => {
        self.imageList[index].preview = previewUrl
      })
    },
    hFlip (index) {
      var self = this
      self.util.resizeImage(self.imageList[index].original, -1, -1, 2, (originalUrl) => {
        self.imageList[index].original = originalUrl
        self.clickImage(index)
      })
      self.util.resizeImage(self.imageList[index].original, 640, 640, 2, (previewUrl) => {
        self.imageList[index].preview = previewUrl
      })
    },
    vFlip (index) {
      var self = this
      self.util.resizeImage(self.imageList[index].original, -1, -1, 4, (originalUrl) => {
        self.imageList[index].original = originalUrl
        self.clickImage(index)
      })
      self.util.resizeImage(self.imageList[index].original, 640, 640, 4, (previewUrl) => {
        self.imageList[index].preview = previewUrl
      })
    },
    clickSave () {
      var self = this
      if (self.isSaving) {
        self.isSaving = false
        return
      }
      self.isSaving = true
      if (self.imageList.length <= 0) {
        self.isSaving = false
        return
      }
      var userProfile = {}
      var uuid = JSON.parse(self.getPromptPaiCookies('Uuid'))
      var isAuthenticated = JSON.parse(self.getPromptPaiCookies('isAuthenticated'))
      if (isAuthenticated) {
        userProfile = JSON.parse(self.getPromptPaiCookies('UserProfile'))
        uuid = undefined
      }
      self.pp.addPromptpaiImage(
        'name' in userProfile ? userProfile.name : undefined,
        'longdousertoken' in userProfile ? userProfile.longdousertoken : undefined,
        isAuthenticated ? undefined : uuid,
        self.promptpaiDescription.promptpai_id,
        self.imageList.map(i => { return i.original }),
        self.imageList.map(i => { return i.comment }),
        undefined,
        (progressEvent) => {
          self.uploadPercentage = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total))
        },
        (c) => {
          self.cancelAddingPromptpaiImage = c
        },
        (result) => {
          if (!result.status) {
          } else if (result.status.code === 200) {
            window.gtag('event', 'add', {'event_category': 'engagement', 'event_label': `add_place_image_${self.promptpaiDescription.promptpai_id}`})
            self.$root.$emit('updatePlaceCard')
            self.clickCloseButton()
          } else if (result.status.code === 401) {
            self.loginAgain()
          } else if (result.status.code === 403) {
          } else {
          }
          self.isSaving = false
        }
      )
    }
  },
  beforeDestroy () {
    var self = this
    self.$root.$off('rotate')
    self.$root.$off('hFlip')
    self.$root.$off('vFlip')
  }
}
</script>

<style scoped>
  .add-place-image-form {
    height: fit-content;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
    margin-top: auto;
    margin-bottom: auto;
    background-color: rgb(255, 255, 255);
  }

  .body {
    height: calc(100% - 50px - 64px);
    box-sizing: border-box;
    overflow: hidden;
    overflow-y: auto;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
  }

  .body::-webkit-scrollbar {
    background-color: rgb(255, 255, 255);
  }
  .body::-webkit-scrollbar-thumb {
    border: 2px solid rgb(255, 255, 255);
  }

  .body > .image {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 320px;
    padding: 16px;
    box-sizing: border-box;
    cursor: pointer;
  }

  .body > .image.add {
    justify-content: center;
    cursor: pointer;
    width: calc(320px - 32px);
    height: calc(320px - 32px);
    padding: 0px;
    margin: 16px;
    border-radius: 8px;
    border: 2px solid rgb(34, 84, 156);
  }

  .body > .image > img {
    width: calc(320px - 32px);
    height: calc(320px - 32px);
    object-fit: cover;
    box-shadow: 0px 0px 2px 1px rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    overflow: hidden;
  }

  .body > .image.add > img {
    object-fit: contain;
    box-shadow: none;
    width: 180px;
    height: 180px;
  }

  .body > .image > .row {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin: 16px 0px 0px 0px;
    width: 100%;
    position: relative;
  }

  .image input {
    width: calc(100% - 36px);
    border: 1px solid rgb(227, 227, 227);
    border-radius: 8px;
    box-sizing: border-box;
    margin: 0px;
    padding: 4px 8px;
    font-size: 16px;
    line-height: 1.75;
  }

  .image input::placeholder {
    color: rgb(175, 175, 175);
    font-size: 16px;
    line-height: 1.75;
  }

  .edit-icon {
    position: absolute;
    top: -52px;
    left: 12px;
    width: 24px;
    height: 24px;
    border-radius: 12px;
    box-sizing: border-box;
    filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.25));
    background-color: rgba(255, 255, 255, 0.9);
  }

  .delete-button {
    width: 36px;
    height: 36px;
    padding: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    background-color: transparent;
    cursor: pointer;
  }

  .delete-button > img {
    width: 28px;
    height: 28px;
  }

  .backdrop {
    position: absolute;
    top: 50px;
    left: 0px;
    height: calc(100% - 50px - 64px);
    width: 100%;
    background-color: rgb(0, 0, 0, 0.8);
    box-sizing: border-box;
    overflow: hidden;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: rgb(255, 255, 255);
  }

  .loading-animation {
    position: absolute;
    left: calc(((100% - 80px) / 2) + 7px);
    top: calc(((100% - 80px) / 2) - 49px);
  }

  .on-upload {
    position: absolute;
    bottom: 64px;
    left: 0px;
    height: 6px;
    background-color: rgba(41, 148, 253, 0.95);
    box-sizing: border-box;
    transition: width 1.5s;
  }

  .footer {
    height: 64px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
  }

  .footer .cancel-button {
    border: none;
    background-color: rgb(74, 74, 74);
    border-radius: 24px;
    color: rgb(255, 255, 255);
    height: 48px;
    padding: 0px 24px;
    box-sizing: border-box;
    font-size: 18px;
    width: 160px;
    margin-right: 16px;
    cursor: pointer;
    font-family: Prompt;
  }

  .footer .save-button {
    border: none;
    background-image: linear-gradient(-180deg, rgb(245, 166, 35) 0%, rgb(251, 147, 73) 100%);
    border-radius: 24px;
    color: rgb(255, 255, 255);
    height: 48px;
    padding: 0px 24px;
    box-sizing: border-box;
    font-size: 18px;
    width: 160px;
    margin-right: 16px;
    cursor: pointer;
    font-family: Prompt;
  }

  .footer .save-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  @media only screen and (max-width: 768px) {
    .add-place-image-form {
      width: 100%;
      min-width: 320px;
      height: 100%;
      border-radius: 0px;
    }

    .footer {
      justify-content: space-around;
    }

    .footer .cancel-button {
      width: calc((100% - 24px) / 2);
      margin-right: 0px;
    }

    .footer .save-button {
      width: calc((100% - 24px) / 2);
      margin-right: 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/AddPlaceImageForm.vue